import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  AttackUpgradeFeature,
  UpgradableNumber,
  WeaponLimitation,
} from "@dndModels";

import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import CheckBox from "@components/input/CheckBox";
import WeaponLimitInput from "@dndComponents/limitations/WeaponLimitInput";

interface Props { 
  obj: AttackUpgradeFeature;
  disabled?: boolean;
  attached_table?: AttachedTable;
  onChange: (changed: AttackUpgradeFeature) => void;
}

export default function AttackUpgradeFeatureInput({ 
  obj,
  onChange,
  disabled = false,
  attached_table
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [myObj, setMyObj] = useState(obj.clone());
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <WeaponLimitInput
          obj={myObj.weapon_limit}
          disabled={disabled}
          onChange={(changed: WeaponLimitation) => {
            const new_obj = myObj;
            new_obj.weapon_limit = changed.clone();
            setMyObj(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <UpgradableNumberBox 
          name="Attack Modifier" 
          value={myObj.attack_modifier} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(value: UpgradableNumber) => {
            const new_ff = myObj;
            new_ff.attack_modifier = value;
            setMyObj(new_ff);
            onChange(new_ff);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <UpgradableNumberBox 
          name="Damage Modifier" 
          value={myObj.damage_modifier} 
          disabled={disabled}
          onChange={(value: UpgradableNumber) => {
            const new_ff = myObj;
            new_ff.damage_modifier = value;
            setMyObj(new_ff);
            onChange(new_ff);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <CheckBox 
          name="Include Attack Ability Modifier" 
          value={myObj.include_ability_mod} 
          disabled={disabled}
          onChange={(value: boolean) => {
            const new_ff = myObj;
            new_ff.include_ability_mod = value;
            setMyObj(new_ff);
            onChange(new_ff);
          }} 
        />
      </Grid>
    </Grid>
  );
}
